import { Component, inject, Input } from '@angular/core';
import { PublicScript, ScriptService } from '../../service/script.service';
import { MatCardModule } from '@angular/material/card';
import { IconComponent } from '../icon/icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { DecimalPipe } from '@angular/common';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'app-script-card',
  imports: [
    MatCardModule,
    IconComponent,
    MatTooltipModule,
    MatChipsModule,
    DecimalPipe,
    AvatarComponent
],
  templateUrl: './script-card.component.html',
  styleUrl: './script-card.component.less'
})
export class ScriptCardComponent {
  @Input() script!: PublicScript;
  scriptService = inject(ScriptService);
  @Input() hideStatus = false;
  @Input() searchQuery = '';

  highlightSearchTerm(text: string, searchTerm: string): string {
    if (!searchTerm || !text) {
      return text;
    }
    
    // Escape special regex characters in the search term
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    
    return text.replace(regex, '<mark>$1</mark>');
  }
}
